module.exports = __webpack_public_path__ + "media/images/gallery/constellations/order_layer_on-b39883de1feea872887c5a539d0f2c95.jpg";